export default __webpack_public_path__ + "static/media/exit.31fe5042.svg";